// THIS FILE IS DUE TO REPLACE THE ORIGINAL routes.js
// KEEPING THE ORIGINAL IT WHILE I WORK ON THE WHOLE REFACTOR
// WITHOUT BREAKING STUFF

import React from 'react';
import { Route, IndexRoute } from 'react-router';
import isEqual from 'lodash/isEqual';
import isEmpty from 'lodash/isEmpty';

import {
    SIGN_IN_METHOD_FACEBOOK_LOGIN,
    SIGN_IN_METHOD_APPLE_LOGIN,
    SOCIAL_EXTERNAL_IDENTITY_PROVIDER_APPLE,
} from '@eb/social-login-facebook';

import {
    checkAccountStatus,
    checkEmailExists,
    setUpForm,
    setUpSocialForm,
    checkPasswordReset,
} from '../common/utils';
import { startSIWATimer } from '../common/utils/siwaTimer';
import { setEmail, forceStld as forceStldAction } from '../common/actions/auth';
import {
    socialLogInUser,
    socialLogInSoftUser,
    socialLogFacebookUser,
} from '../common/actions/social';

import {
    RESET_PASSWORD_STATUS_PATH,
    SOFT_ACCOUNT_STATUS_PATH,
    LOG_IN_PATH,
    SIGN_UP_PATH,
    SOCIAL_SIGN_UP_PATH,
    SOCIAL_LOOK_UP_PATH,
    SOCIAL_LOG_IN_PATH,
    SOCIAL_LINK_LOGIN_PATH,
    LINK_ACCOUNTS_LOG_IN_PATH,
    CONFIRMATION_PATH,
    BASE_URL,
    RESET_PASSWORD_PATH,
    SET_PASSWORD_PATH,
    SET_LINKED_SOFT_ACCOUNTS_PATH,
    LINK_SOCIAL_ACCOUNT_PATH,
    STATUS_PATH,
} from '../common/constants';

import Page from './Page';

import ConnectedConfirmationPage from '../common/containers/confirmation/ConnectedConfirmationPage';
import ConnectedLinkAccountsLoginPage from '../common/containers/linkAccountsLogin/ConnectedLinkAccountsLoginPage';
import ConnectedLoginPage from '../common/containers/login/ConnectedLoginPage';
import ConnectedResetPasswordPage from '../common/containers/resetPassword/ConnectedResetPasswordPage';
import ConnectedResetPasswordStatusPage from '../common/containers/resetPasswordStatus/ConnectedResetPasswordStatusPage';
import ConnectedSetLinkedSoftAccountsPage from '../common/containers/setLinkedSoftAccounts/ConnectedSetLinkedSoftAccountsPage';
import ConnectedSetPasswordPage from '../common/containers/setPassword/newConnectedSetPasswordPage';
import ConnectedSignupPage from '../common/containers/signup/ConnectedSignupPage';
import ConnectedSocialLinkPage from '../common/containers/socialLink/ConnectedSocialLinkPage';
import ConnectedSocialLoginPage from '../common/containers/socialLogin/ConnectedSocialLoginPage';
import ConnectedSocialLookupPage from '../common/containers/socialLookup/ConnectedSocialLookupPage';
import ConnectedSocialSignupPage from '../common/containers/socialSignup/ConnectedSocialSignupPage';
import ConnectedSoftAccountStatusPage from '../common/containers/softAccountStatus/ConnectedSoftAccountStatusPage';
import ConnectedSocialLinkedAccountPage from '../common/containers/socialLinkedAccount/ConnectedSocialLinkedAccountPage';

const getRoutes = (pageInfo, store) => {
    const PageWithInfo = (props) => <Page {...pageInfo} {...props} />;

    const _checkAccountStatus = (nextRouterState, replace) => {
        checkAccountStatus(store, replace);
    };

    const setUpSocialSingUpFormOnEnter = (nextRouterState, replace) => {
        setUpSocialForm(store, replace);
    };

    const setUpFormOnEnter = async ({ location: { query } }) => {
        // Unknown usage
        if (query.email) {
            store.dispatch(setEmail(query.email));
        }

        setUpForm(store);
    };

    const checkSocialToken = (nextRouterState, replace) => {
        const {
            authentication: {
                socialAuthenticationData: { apple: { accessToken } = {} } = {},
            } = {},
        } = store.getState();

        if (!accessToken) {
            replace(BASE_URL);
        }
    };

    const setUpSocialLinkFormOnEnter = ({ location: { query } }, replace) => {
        const {
            authentication: {
                socialAuthenticationData: { apple: { email } = {} },
            } = {},
        } = store.getState();

        if (email) {
            store.dispatch(setEmail(email));
        } else {
            replace(BASE_URL);
        }

        setUpForm(store);
    };

    const checkEmailOnEnter = (nextRouterState, replace) => {
        checkEmailExists(store, replace);
    };

    const checkResetOnEnter = ({ location: { query, pathname } }, replace) => {
        checkPasswordReset(store, query, replace, pathname);
    };

    const redirectFromOldUrl = (nextRouterState, replace) => {
        replace(BASE_URL);
    };

    return (
        <Route path={BASE_URL} component={PageWithInfo}>
            <IndexRoute
                onEnter={setUpFormOnEnter}
                component={ConnectedLoginPage}
            />

            {/* Account check */}
            <Route
                path={SOCIAL_LOOK_UP_PATH}
                component={ConnectedSocialLookupPage}
                onEnter={checkSocialToken}
            />

            {/* Account login */}
            <Route path={LOG_IN_PATH} onEnter={redirectFromOldUrl} />

            <Route
                path={SOCIAL_LOG_IN_PATH}
                component={ConnectedSocialLoginPage}
                onEnter={_checkAccountStatus}
            />

            {/* Account confirmation */}
            <Route
                path={CONFIRMATION_PATH}
                component={ConnectedConfirmationPage}
            />

            {/* Account creation */}
            <Route path={SIGN_UP_PATH} component={ConnectedSignupPage} />

            <Route
                path={SOCIAL_SIGN_UP_PATH}
                component={ConnectedSocialSignupPage}
                onEnter={setUpSocialSingUpFormOnEnter}
            />

            {/* Account link */}
            <Route
                path={SOCIAL_LINK_LOGIN_PATH}
                component={ConnectedSocialLinkPage}
                onEnter={setUpSocialLinkFormOnEnter}
            />

            <Route
                path={LINK_ACCOUNTS_LOG_IN_PATH}
                component={ConnectedLinkAccountsLoginPage}
                onEnter={_checkAccountStatus}
            />

            <Route
                path={SET_LINKED_SOFT_ACCOUNTS_PATH}
                component={ConnectedSetLinkedSoftAccountsPage}
                onEnter={checkEmailOnEnter}
            />

            {/* Password pages */}
            <Route
                path={RESET_PASSWORD_PATH}
                component={ConnectedResetPasswordPage}
                onEnter={checkResetOnEnter}
            />

            <Route
                path={SET_PASSWORD_PATH}
                component={ConnectedSetPasswordPage}
                onEnter={checkResetOnEnter}
            />

            <Route
                path={LINK_SOCIAL_ACCOUNT_PATH}
                component={ConnectedSocialLinkedAccountPage}
            />

            <Route path={STATUS_PATH}>
                <Route
                    path={SOFT_ACCOUNT_STATUS_PATH}
                    component={ConnectedSoftAccountStatusPage}
                />
                <Route
                    path={RESET_PASSWORD_STATUS_PATH}
                    component={ConnectedResetPasswordStatusPage}
                />
            </Route>
        </Route>
    );
};

export default getRoutes;
